import { RootState } from '@/core/store/store'
import { createSelector } from '@reduxjs/toolkit'

const affiliate = (state: RootState) => state.affiliateReducer
export const affiliateSelector = createSelector(
  affiliate,
  affiliateReducer => affiliateReducer.affiliate,
)
